import "./i18n";
import "stores/RootStore";
import "./styles/index.scss";
import "dayjs/locale/en-in";

import { DatesProvider } from "@mantine/dates";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { APIProvider } from "@vis.gl/react-google-maps";
import Backdrop from "components/Backdrop";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { queryClient } from "./query-client";

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: localStoragePersister,
        maxAge: 1000 * 60 * 60 * 24,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Backdrop />}>
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}>
            <DatesProvider
              settings={{
                locale: "en-in",
                firstDayOfWeek: 1,
                weekendDays: [0, 6],
              }}
            >
              <App />
            </DatesProvider>
          </APIProvider>
        </Suspense>
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      </QueryClientProvider>
    </PersistQueryClientProvider>
  </React.StrictMode>
);
